import { Controller } from 'stimulus';

export default class extends Controller {
  static get targets() {
    return ['body', 'header', 'chevron', 'expandLabel', 'collapseLabel', 'overlay'];
  }

  static values = { dismissUrl: String };

  initialize() {
    this.expanded = false;
    this.repositionOverlay = this.repositionOverlay.bind(this);
    this.syncAria();
  }

  disconnect() {
    this.stopTrackingOverlay();
  }

  toggle(event) {
    if (event) event.preventDefault();
    this.expanded = !this.expanded;
    this.syncAria();
  }

  collapse(event) {
    if (event) event.preventDefault();
    if (!this.expanded) return;

    this.expanded = false;
    this.syncAria();
  }

  syncAria() {
    if (!this.hasBodyTarget) return;

    this.bodyTarget.classList.toggle('tw-hidden', !this.expanded);
    this.element.setAttribute('aria-expanded', this.expanded);

    if (this.hasChevronTarget) {
      this.chevronTarget.style.transform = this.expanded ? 'rotate(180deg)' : 'rotate(0deg)';
    }
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.toggle('tw-hidden', !this.expanded);
      if (this.expanded) {
        this.repositionOverlay();
        this.startTrackingOverlay();
      } else {
        this.stopTrackingOverlay();
      }
    }
    if (this.hasExpandLabelTarget) {
      this.expandLabelTarget.classList.toggle('tw-hidden', this.expanded);
    }
    if (this.hasCollapseLabelTarget) {
      this.collapseLabelTarget.classList.toggle('tw-hidden', !this.expanded);
    }
  }

  repositionOverlay() {
    if (!this.hasOverlayTarget) return;

    const anchor = this.hasHeaderTarget ? this.headerTarget : this.element;
    const top = Math.max(anchor.getBoundingClientRect().bottom, 0);
    this.overlayTarget.style.top = top + 'px';
  }

  startTrackingOverlay() {
    window.addEventListener('scroll', this.repositionOverlay, { passive: true });
    window.addEventListener('resize', this.repositionOverlay);
  }

  stopTrackingOverlay() {
    window.removeEventListener('scroll', this.repositionOverlay);
    window.removeEventListener('resize', this.repositionOverlay);
  }

  async dismiss(event) {
    if (event) event.preventDefault();

    const url = this.dismissUrlValue;
    const csrfTokenEl = document.querySelector('meta[name="csrf-token"]');
    const csrfToken = csrfTokenEl ? csrfTokenEl.content : '';

    try {
      await fetch(url, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': csrfToken,
          Accept: 'application/json',
        },
        credentials: 'same-origin',
      });
    } catch (e) {
      // network failure: still hide locally so the user gets feedback.
    }

    this.element.remove();
  }
}
